import { Sidebar } from 'primereact/sidebar';
import React, { useState } from 'react';
import Select from "react-select";
import { propertySaleTypes } from '../../../Enum';

const PropertiesFilter = ({ isSliderOpen, onHide , filterProperty }) => {
  const [selectedSaleType, setSelectedSaleType] = useState(null);
  const [selectedPlotStatus, setSelectedPlotStatus] = useState(null);

  const plotStatusIds = [
    { id: "aufs9LEstTH1jkd1lcjD", label: "Available" },
    { id: "ylDevuPUDBzdGXM44j1P", label: "Sold" }
  ];

  const handleApply = () => {
    const filters = {
      saleType: selectedSaleType,
      plotStatus: selectedPlotStatus,
    };
    console.log("Applied Filters:", filters);
    filterProperty(filters);
  
    onHide();
  };

  const handleClear = () => {
    const filters = {
      saleType: null,
      plotStatus: null,
    };
    filterProperty(filters);
    setSelectedSaleType(null);
    setSelectedPlotStatus(null);
  };

  return (
    <Sidebar
      header={
        <div className="flex items-center justify-between w-full">
          <span className="font-semibold text-lg text-customGreen">
            <h3>Filters</h3>
          </span>
        </div>
      }
      visible={isSliderOpen}
      onHide={onHide}
      style={{ width: "560px" }}
      position="right"
      className="p-sidebar-md"
    >
      <div className="flex flex-col h-full justify-between gap-4 pb-20">
        <div className="flex flex-col gap-4">
          {/* Property Sale Type */}
          <Select
            options={propertySaleTypes}
            value={selectedSaleType}
            onChange={setSelectedSaleType}
            placeholder="Select Sale Type"
            getOptionLabel={(e) => e.label}
            getOptionValue={(e) => e.id}
          />

          {/* Property Status */}
          {/* <Select
            options={plotStatusIds}
            value={selectedPlotStatus}
            onChange={setSelectedPlotStatus}
            placeholder="Select Plot Status"
            getOptionLabel={(e) => e.label}
            getOptionValue={(e) => e.id}
          /> */}
        </div>

        {/* Footer Buttons */}
        <div className="flex flex-col gap-4 absolute bottom-4 w-[calc(100%-2rem)] px-4">
          <button
            className="bg-customGreen w-full text-white px-4 py-2 rounded-md"
            onClick={handleApply}
          >
            Apply
          </button>
          <button
            className="bg-white text-red-500 w-full border border-customGreen py-2 px-4 rounded-md"
            onClick={handleClear}
          >
            Clear
          </button>
        </div>
      </div>
    </Sidebar>
  );
};

export default PropertiesFilter;
